<template>
  <b-container>
    <b-row style="margin-top:25px">
      <b-card-group deck v-loading="loading">
        <b-card header="Firma Renkleri" header-tag="header">
            <b-row>
              <b-col cols="2">
                <b-form-group label="Ana Renk">
                    <el-color-picker v-model="formData.main"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Arkaplan">
                    <el-color-picker v-model="formData.background"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Alt Renk">
                    <el-color-picker v-model="formData.sub"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Header Arkaplan">
                    <el-color-picker v-model="formData.header"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Header Yazı Renk">
                    <el-color-picker v-model="formData.header_text"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Buton Rengi">
                    <el-color-picker v-model="formData.button_text"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Footer Arkaplan">
                    <el-color-picker v-model="formData.footer"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Footer Yazı Renk">
                    <el-color-picker v-model="formData.footer_text"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Site Rengi">
                    <el-color-picker v-model="formData.text"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="2. Buton">
                    <el-color-picker v-model="formData.button_secondary"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="2. Buton Rengi">
                    <el-color-picker v-model="formData.button_secondary_text"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Açık Buton">
                    <el-color-picker v-model="formData.button_light"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Açık Buton Rengi">
                    <el-color-picker v-model="formData.button_light_text"></el-color-picker>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group style="margin-top:32px">
                    <b-button @click="send()" size="sm" variant="primary">Renkleri Güncelle</b-button>
                  </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'CompaniesDetailColor',
    data(){
      return{
        id: this.$route.params.id,
        loading: false,
        formData: {
          main: null,
          background:null,
          header:null,
          header_text:null,
          sub:null,
          footer:null,
          footer_text:null,
          text:null,
          button_text:null,
          button_secondary:null,
          button_secondary_text:null,
          button_light:null,
          button_light_text:null,
        }
      }
    },
    created(){
      this.fetch();
    },
    methods:{
      fetch(){
        this.loading = true;
        axios.get('/client/' + this.id + '/detail')
        .then((response) => {
            if(!_.isEmpty(response.data.data.color)){
              this.formData = response.data.data.color;  
            }
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
      send(){
        this.loading = true;
        axios.post('/client/' + this.id + '/color', this.formData)
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'success', title: 'Güncelleme Başarılı'});
            //this.$router.push({name: 'Companies'});
            this.fetch();
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
    }
  }
</script>